import { render, staticRenderFns } from "./ReferencesSelector.vue?vue&type=template&id=1891ba76&scoped=true"
import script from "./ReferencesSelector.vue?vue&type=script&lang=js"
export * from "./ReferencesSelector.vue?vue&type=script&lang=js"
import style0 from "./ReferencesSelector.vue?vue&type=style&index=0&id=1891ba76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1891ba76",
  null
  
)

export default component.exports